<!--  -->
<template>
    <div class="g-table" :class="{border,striped}">
        <table>
            <thead>
                <tr>
                    <th>
                        <input
                            ref="allChecked"
                            :checked="dataSource.length === value.length"
                            type="checkbox"
                            @change="selectAll"
                        />
                    </th>
                    <th v-if="showIndex">#</th>
                    <th :key="index" v-for="(item,index) in columns">
                        {{item.text}}
                        <!-- <span class="g-table-sorter">
                            <g-icon icon="solidup" />
                            <g-icon icon="soliddown" />
                        </span>-->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr :key="index" v-for="(item,index) in dataSource">
                    <td>
                        <input
                            :checked="isChecked(item)"
                            type="checkbox"
                            @change="selectItem(item,index,$event)"
                        />
                    </td>
                    <td v-if="showIndex">{{index+1}}</td>
                    <td :key="key" v-for="(value,key) in columns">{{item[value.filed]}}</td>
                </tr>
            </tbody>
        </table>
        <div v-if="loading" class="g-table-loading">
            <g-icon icon="loading" />
        </div>
    </div>
</template>

<script>
import GIcon from './icon'
export default {
    name: 'g-table',
    components: {
        GIcon
    },
    props: {
        columns: {
            type: Array,
            required: true
        },
        dataSource: {
            type: Array,
            required: true
        },
        value: {
            type: Array,
            default: () => []
        },
        showIndex: {
            type: Boolean,
            default: false
        },
        border: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        selectItem(item, index, e) {
            const selectedList = JSON.parse(JSON.stringify(this.value))
            const arr1 = Object.values(item)
            let num
            if (!e.target.checked) {
                selectedList.forEach((value, index) => {
                    const arr2 = Object.values(value)
                    let c = true
                    arr1.forEach((a, b) => {
                        if (arr2[b] !== a) {
                            c = false
                        }
                    })
                    if (c) {
                        num = index
                    }
                })
                selectedList.splice(num, 1)
            } else {
                selectedList.push(item)
            }
            this.$emit('input', selectedList)
        },
        selectAll(e) {
            this.$emit('input', e.target.checked ? this.dataSource : [])
        },
        isChecked(item) {
            const arr1 = Object.values(item)
            let flag
            this.value.forEach((value, index) => {
                const arr2 = Object.values(value)
                let c = true
                arr1.forEach((a, b) => {
                    if (arr2[b] !== a) {
                        c = false
                    }
                })
                if (c) {
                    flag = c
                }
            })
            return flag
        }
    },
    watch: {
        value() {
            if (
                this.value.length > 0 &&
                this.value.length < this.dataSource.length
            ) {
                this.$refs.allChecked.indeterminate = true
            } else {
                this.$refs.allChecked.indeterminate = false
            }
        }
    }
}
</script>
<style scoped lang='scss'>
@import './var';
$grey: darken($grey, 10%);
.g-table {
    position: relative;
    &.border {
        td,
        th {
            border: 1px solid #f0f0f0;
        }
    }
    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        td,
        th {
            border-bottom: 1px solid #f0f0f0;
            text-align: left;
            padding: 8px;
        }
        thead {
            tr {
                th {
                }
            }
        }
        tbody {
            tr {
            }
        }
    }
    &.striped {
        table {
            tbody {
                tr {
                    &:nth-child(odd) {
                        background-color: #fff;
                    }
                    &:nth-child(even) {
                        background-color: #fafafa;
                    }
                }
            }
        }
    }
    &-sorter {
        display: inline-flex;
        flex-direction: column;
        vertical-align: middle;
        svg {
            width: 10px;
            height: 10px;
            fill: $grey;
            cursor: pointer;
        }
    }
    &-loading {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background:rgba(255,255,255,.8);
        display:flex;
        justify-content:center;
        align-items:center;
        svg {
            @include spin;
            width: 50px;
            height: 50px;
        }
    }
}
</style>